export const PLACEHOLDER_RE = /{{([a-zA-Z_][a-zA-Z0-9_]*)}}/g;

export const extractPlaceholders = (bodyContent = "") => {
  const found = [];
  const seen = new Set();
  const text = String(bodyContent || "");
  let match;
  const re = new RegExp(PLACEHOLDER_RE.source, "g");
  while ((match = re.exec(text)) !== null) {
    const key = match[1];
    if (!seen.has(key)) {
      seen.add(key);
      found.push(key);
    }
  }
  return found;
};

export const hasEmptyPlaceholder = (bodyContent = "") =>
  /\{\{\s*\}\}/.test(String(bodyContent || ""));

export const substituteSampleValues = (bodyContent = "", sampleValues = {}) => {
  return String(bodyContent || "").replace(PLACEHOLDER_RE, (_, key) => {
    const value = sampleValues?.[key];
    if (value === undefined || value === null || value === "") {
      return `{{${key}}}`;
    }
    return String(value);
  });
};

export const validateTemplateDraft = (draft) => {
  const errors = {};
  if (!draft?.language?.trim()) {
    errors.language = ["Language is required"];
  }
  if (!draft?.category?.trim()) {
    errors.category = ["Category is required"];
  }
  if (!draft?.body_content?.trim()) {
    errors.body_content = ["Body content is required"];
  }
  if (hasEmptyPlaceholder(draft?.body_content)) {
    errors.body_content = [
      ...(errors.body_content || []),
      "Empty placeholders {{}} are not allowed",
    ];
  }
  return Object.keys(errors).length ? errors : null;
};

export const buildSavePayload = (draft) => {
  const variables = extractPlaceholders(draft?.body_content);
  const sampleValues = { ...(draft?.sample_values || {}) };
  variables.forEach((key) => {
    if (sampleValues[key] === undefined) sampleValues[key] = "";
  });

  return {
    name: draft.name,
    display_name: draft.display_name ?? "",
    language: draft.language,
    category: draft.category,
    header_type: draft.header_type || "NONE",
    body_content: draft.body_content,
    variables,
    sample_values: sampleValues,
    ...(draft.source !== undefined ? { source: draft.source } : {}),
    ...(draft.scan_attendance !== undefined
      ? { scan_attendance: draft.scan_attendance }
      : {}),
  };
};
